module.exports = __webpack_public_path__ + "media/images/svg/logo-952a5046cb39cfadae1427c4a6e313c8.svg";